
import { useMutation } from '@tanstack/vue-query'
import OrganisationReport from '@/api/Dara/OrganisationReport'
import { useAuthStore } from '@/stores/auth'
import { useInvalidateQueries as useInvalidateOrganisationResourceQueries } from '@/composable/queries/Dara/organisationResources'

interface AdviserNotesData {
  programme_id: number;
  student_ids: number[];
  type?: Domain.Students.Enums.StudentNoteType;
}

interface MyUCPersonalStatementData {
  state: App.Enums.Reports.PersonalStatementReportState;
  file_type: App.Enums.MyPDFFileType;
  organisation_academic_year_id: number | 'all';
  year_group_id: number | null | 'all' | 'none';
  sub_group_id: number | null | 'all' | 'none';
}

export const useGenerateAdviserNotes = () => {
  const authStore = useAuthStore()
  const { invalidateOrganisationResourceQuery } = useInvalidateOrganisationResourceQueries()

  return useMutation({
    mutationFn: (formData: AdviserNotesData) => OrganisationReport.adviserNotes(authStore.organisation?.id ? authStore.organisation?.id : 0, formData),

    onSuccess: () => {
      invalidateOrganisationResourceQuery(authStore.organisation?.id ? authStore.organisation?.id : 0)
    },
  })
}

export const useGenerateMyUCPersonalStatement = () => {
  const authStore = useAuthStore()
  const { invalidateOrganisationResourceQuery } = useInvalidateOrganisationResourceQueries()

  return useMutation({
    mutationFn: (formData: MyUCPersonalStatementData) => OrganisationReport.myUCPersonalStatement(authStore.organisation?.id ? authStore.organisation?.id : 0, formData),

    onSuccess: () => {
      invalidateOrganisationResourceQuery(authStore.organisation?.id ? authStore.organisation?.id : 0)
    },
  })
}
